<template>
  <div class="auth-button-component">
    <button class="btn" :disabled="disabled" @click="$emit('click')">
      <div class="button-background" />
      <loading :show="loading">
        <span>{{ text }}</span>
      </loading>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.auth-button-component {
  ::v-deep .btn {
    width: 100%;
    height: 58px;
    font-weight: 500;
    box-shadow: none;
    color: white;
    background: transparent;
    padding-block: 14px;
    font-size: 18px;
    transition: opacity 0.2s;
    @media screen and (max-width: 1280px) {
      height: 48px;
    }

    span {
      z-index: 20;
    }
    &.disabled,
    &:disabled {
      opacity: 0.4;
    }
    &::before {
      content: "";
      top: 0px;
      left: 0px;
      height: 56px;
      width: 100%;
      z-index: 100;
      border-radius: 3px;
      position: absolute;
      transition: 0.2s opacity;

      @media screen and (max-width: 1280px) {
        height: 48px;
      }

      background: repeating-linear-gradient(180deg, #a2b5fb, #a2b5fb),
        linear-gradient(180deg, #dae1fb, #889ce2),
        linear-gradient(
          90deg,
          #a2b5fb 4%,
          #5273eb 20%,
          #2f4bb1 30%,
          #2f4bb1 45%,
          #546dc9 65%,
          #dae1fb 95%
        ),
        linear-gradient(
          90deg,
          #a2b5fb 13%,
          #5273eb 25%,
          #2f4bb1 55%,
          #2f4bb1 75%,
          #889ce2 90%
        );
      background-size: 2px 100%, 2px 100%, 100% 2px, 100% 2px;
      background-position: 0 0, 100% 0, 0 0, 0 100%;
      background-repeat: no-repeat;
    }
    &:not(:disabled) {
      &:hover {
        .button-background {
          opacity: 0.64;
        }
      }
      &:active {
        .button-background {
          opacity: 0.8;
        }
      }
    }

    .button-background {
      z-index: -10;
      inset: 0;
      opacity: 0.24;
      position: absolute;
      transition: 0.2s all;
      border-radius: 4px;
      background: linear-gradient(
          0deg,
          rgba(0, 24, 112) 0%,
          rgba(0, 24, 112) 100%
        ),
        radial-gradient(
          49.13% 240.28% at 50% 50%,
          rgba(0, 24, 112, 0.15) 0%,
          rgba(0, 24, 112, 0.04) 100%
        );
    }
  }
}
</style>
